import VoteModalDOM from "./_dom";
import VoteAPI from "../api/main";

export default class VoteModal {
    constructor() {
        this._init();
    }

    show(_delay = 0) {
        setTimeout(() => {
            this.dom.setup(this.settings);
            this._checkMoreView();
            this._pageFix();
            this.$self.setAttribute("data-step", "vote");
            this.$self.setAttribute("data-acc", "close");
            this.$self.classList.add("-active");
            window.scrollTo(0, 0);
        }, _delay);
    }

    hide() {
        this._pageRet();
        this.$self.classList.remove("-active");
    }

    _init() {
        this.TRANSITION_DELAY = 600;

        this.$main = document.querySelector(".l-main");
        this.$self = document.querySelector(".js-vmodal");
        this.$btnAcc = document.querySelector(".js-vmodal__acc");
        this.votelistmains = [...document.querySelectorAll(".votelist__main")];

        this.api = new VoteAPI();

        this.dom = new VoteModalDOM();

        const votelist = window.sao.votelist;
        this.data = {};
        for (let i = 0; i < votelist.length; i++) {
            const id = votelist[i].id;
            this.data[id] = votelist[i];
        }
        this.settings = {};
        this.sy = 0;

        this._ui();
    }

    _ui() {
        // モーダルの起動
        [...document.querySelectorAll(".votelist")].forEach(($votelist) => {
            const series = $votelist.getAttribute("data-id");

            [...$votelist.querySelectorAll(".votelist__item")].forEach(($item) => {
                const idx = $item.getAttribute("data-index");

                $item.addEventListener("click", () => {
                    this._getData(series, idx);
                    this.show(this.TRANSITION_DELAY);
                });
            });
        });

        // モーダルを閉じる
        document.querySelector(".js-vmodal__close").addEventListener("click", () => {
            this.hide();
        });

        // document.querySelector(".js-vmodal__reset").addEventListener("click", () => {
        //     this.hide();
        // });

        // 投票の送信
        // document.querySelector(".js-vmodal__submit").addEventListener("click", () => {
        //     this.api.send(this.settings, () => {
        //         setTimeout(() => {
        //             this.$self.setAttribute("data-step", "complete");
        //         }, this.TRANSITION_DELAY);
        //     });
        // });

        // アコーディオン
        this.$btnAcc.addEventListener("click", () => {
            const acc = this.$self.getAttribute("data-acc");

            if (acc === "close") {
                this.$self.setAttribute("data-acc", "open");
            } else {
                this.$self.setAttribute("data-acc", "close");
            }
        });
    }

    _getData(key, index) {
        const nowdata = this.data[key];
        const nowitem = nowdata["items"][index];

        this.settings = {
            sholder: nowdata["sholder"],
            series: nowdata["series"],
            key: key,
            title: nowitem["title"],
            storyNo: nowitem["storyNo"],
            text: nowitem["text"],
            image: `/assets/img/vote/main/${key}/ph${nowitem["storyNo"]}.jpg`,
        };

        if (this.settings.key === "sao1" && this.settings.storyNo === "24") {
            this.settings.title = "鍍金(メッキ)の勇者";
        }
    }

    _pageFix() {
        this.sy = window.scrollY;
        this.$main.style.position = "fixed";
        this.$main.style.top = `-${this.sy}px`;
    }

    _pageRet() {
        this.votelistmains.forEach(($elem) => {
            $elem.removeAttribute("style");
        });

        this.$main.style.position = "relative";
        this.$main.style.top = 0;
        window.scrollTo(0, this.sy);
    }

    _checkMoreView() {
        setTimeout(() => {
            const $span = document.querySelector(".js-vmodal__text span");
            const h = $span.getBoundingClientRect().height;

            if (h <= 70) this.$btnAcc.classList.add("-disable");
            else this.$btnAcc.classList.remove("-disable");
        }, 0);
    }
}
